import React from 'react';
import { get } from 'lodash';
import { useSelector } from 'react-redux';

import { selectUiLabels } from '../appConfig/selector';

export const makeLabel = (labels, tag, reserve) => {
  const mappedLabel = get(labels, tag) || reserve;

  return mappedLabel || tag;
};

const MappedLabel = ({ children, reserve }) => {
  const labels = useSelector(selectUiLabels);

  return <>{makeLabel(labels, children, reserve)}</>;
};

export default MappedLabel;
